import LiWorkflowForm from "./src/index.vue";

LiWorkflowForm.install = function (Vue) {
  Vue.component(LiWorkflowForm.name, LiWorkflowForm);
};

export default LiWorkflowForm;
